export const LOGIN_STORE_OWNER_USER = "LOGIN_STORE_OWNER_USER";
export const LOGOUT_STORE_OWNER_USER = "LOGOUT_DELIVERY_USER";
